<template>
  <dialog class="popup" id="google_remove">
    <div class="popup-box" style="max-width: 464px;">
      <button type="button" class="popup-close" @click="hide"></button>
      <div class="popup-header">Unlink Google account</div>
      <div class="popup-content center">
        <div class="popup-message">Are you sure you want to unlink account?</div>
        <button type="button" class="button" @click="Delete">Unlink anyway</button>
      </div>
    </div>
  </dialog>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "PGoogleRemove",
  data: function () {
    return {
      is_open: false,
    }
  },
  computed: {
    ...mapState({
      is_auth: state => state.User.is_auth,
      popup_additional_data: state => state.Popups.popup_additional_data,
    }),
  },
  mounted() {
    setTimeout(() => {
      this.is_open = true;
    }, 100);
  },
  methods: {
    ...mapMutations(['SetPopupData',]),
    ...mapActions(['PostCall', 'GetScopeUpdate']),

    Delete() {
      this.PostCall({
        endpoint: '/users/resetgoogle/',
        callback: (data) => {
          console.log(data);
          this.GetScopeUpdate({change_user: true});
          this.hide();
        },
        on_error: (error) => {
          let error_status = error.response.status;
          console.log(error_status);
        },
      })
    },


    hide() {
      this.is_open = false;
      setTimeout(() => {
        this.SetPopupData({popup_opened: false});
      }, 300);
    },
  },
  watch: {
    is_auth(newVal) {
      if (newVal === false) {
        this.hide();
      }
    },
  },
}
</script>

<style scoped>

</style>
